import { useQuery } from 'react-query';
import { documentsService } from 'hq/services';
import { QUERY_KEYS } from 'api/query-keys';
import { GetDocumentForFlexWorkerResponse } from 'hq/services/documents-service.types';

export const useGetDocumentForFw = (flexWorkerId: string, documentType: string) => {
  return useQuery<GetDocumentForFlexWorkerResponse | null, Error>({
    queryKey: QUERY_KEYS.documentForFlexWorker(flexWorkerId, documentType),
    queryFn: () => {
      return documentsService.findDocumentForFlexWorker(flexWorkerId, documentType);
    },
    enabled: !!flexWorkerId && !!documentType,
  });
};
